import API from '@aws-amplify/api';
import { atom, selector } from 'recoil';

import Utils from '@/common/utils/utils';
import { getUnReadNotificationListOfUser } from '@/service/notificationService';
import Constant from '@/common/constant/Constant';
import { getNotificationMsg } from '@/component/notification/handler/SubsciptionHandler';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { getListAllProjectOfUser } from '@/service/projectService';
import { getUserNotificationList } from '@/component/notification/handler/NotificationHandler';

export const notificationListAtom = atom({
    key: 'notificationListAtom',
    default: selector({
        key: 'notificationListSelector',
        get: async ({ get }) => {
            let userId = localStorageUtil.getUserDetailId();
            let corporationId = localStorageUtil.getAffiliationOrganization();

            return getUserNotificationList(corporationId, userId);
        },
        cachePolicy_UNSTABLE: {
            // Only store the most recent set of dependencies and their values
            eviction: 'most-recent',
        },
    })
});



export const notificationUnReadListAtom = atom({
    key: 'notificationUnReadListAtom',
    default: selector({
        key: 'notificationUnReadListSelector',
        get: async ({ get }) => {
            let userId = localStorageUtil.getUserDetailId();
            let corporationId = localStorageUtil.getAffiliationOrganization();

            let projectList = await getListAllProjectOfUser(API, corporationId, userId);

            // get project list
            if (Utils.isEmptyArray(projectList)) {
                return [];
            }

            let projectListRequest = [];
            projectList.forEach(project => {
                projectListRequest.push({ id: project.id, createdAt: project.createdAt });
            });

            let noticationList = await getUnReadNotificationListOfUser(
                API,
                projectListRequest,
                Constant.TYPE_GET_NOTIFICATION_LIST.UNREAD
            );
            noticationList.forEach(msg => {
                msg.notificationMsg = getNotificationMsg(msg);
            });

            noticationList = noticationList.filter(msg => msg.notificationMsg !== '');

            // sort by desc createdAt
            noticationList = Utils.sortByCreatedAtDesc(noticationList);

            return noticationList;
        },
        cachePolicy_UNSTABLE: {
            // Only store the most recent set of dependencies and their values
            eviction: 'most-recent',
        }
    })
});

export const currentPageNoticationListAtom = atom({
    key: 'currentPageNoticationListAtom',
    default: 1
})
